import * as React from "react";
import { HelpCircle, LucideIcon } from "lucide-react";
import { Label } from "./label";
import { Switch } from "./switch";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";

interface SwitchWithLabelProps {
  label: string;
  subline?: string;
  tooltip?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  icon?: LucideIcon;
  className?: string;
  disabled?: boolean;
}

export function SwitchWithLabel({
  label,
  subline,
  tooltip,
  checked,
  onCheckedChange,
  icon: Icon,
  className = "",
  disabled = false,
}: SwitchWithLabelProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex gap-2">
          {Icon && (
            <div className="self-center">
              <Icon className={`h-4 w-4 shrink-0 text-primary ${disabled ? 'opacity-50' : ''}`} />
            </div>
          )}
          <div className={subline ? 'space-y-1' : ''}>
            <div className="flex items-center gap-2">
              <Label className={`text-sm font-medium ${disabled ? 'opacity-50' : ''}`}>{label}</Label>
              {tooltip && (
                <TooltipProvider delayDuration={200}>
                  <Tooltip>
                    <TooltipTrigger>
                      <HelpCircle className={`h-4 w-4 text-muted-foreground ${disabled ? 'opacity-50' : ''}`} />
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="max-w-xs">{tooltip}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            </div>
            {subline && <p className={`text-xs text-muted-foreground ${disabled ? 'opacity-50' : ''}`}>{subline}</p>}
          </div>
        </div>
        <Switch
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
          className={disabled ? 'opacity-50' : ''}
        />
      </div>
    </div>
  );
}
